import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { memo, useCallback, useState } from 'react';
import Avatar, { AvatarSize } from "../../../avatar";
import DropdownMenu, { DropdownContainer, DropdownLink, DropdownSection, DropdownTrigger } from "../../../dropdown-menu";
import { UserDetails, UserEmail, UserInfoBox, UserName } from "./user-dropdown.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var UserDropdown = function UserDropdown(_ref) {
  var menuItems = _ref.menuItems,
    user = _ref.user,
    onUserMenuClick = _ref.onUserMenuClick,
    onUserMenuItemClick = _ref.onUserMenuItemClick;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDropdown = _useState2[0],
    setShowDropdown = _useState2[1];
  var handleDropdownTrigger = useCallback(function (event) {
    onUserMenuClick === null || onUserMenuClick === void 0 ? void 0 : onUserMenuClick(event);
    setShowDropdown(function (dropdownState) {
      return !dropdownState;
    });
  }, [onUserMenuClick]);
  var handleDropdownClose = useCallback(function () {
    return setShowDropdown(false);
  }, []);
  var handleMenuItemClick = useCallback(function (menuItem) {
    return function (event) {
      onUserMenuItemClick === null || onUserMenuItemClick === void 0 ? void 0 : onUserMenuItemClick({
        item: menuItem,
        event: event
      });
    };
  }, [onUserMenuItemClick]);
  if (!user) {
    return /*#__PURE__*/_jsx(Avatar.Skeleton, {
      size: AvatarSize.Large
    });
  }
  var triggerId = 'user-dropdown-toggle';
  var menuId = 'user-dropdown';
  return /*#__PURE__*/_jsxs(DropdownContainer, {
    children: [/*#__PURE__*/_jsx(DropdownTrigger, {
      "data-testid": "mega-menu-user",
      id: triggerId
      // @ts-expect-error Ginger Dropdown is not transformed to TS yet
      ,

      menuId: menuId,
      open: showDropdown,
      onClick: handleDropdownTrigger,
      children: /*#__PURE__*/_jsx(Avatar, {
        email: user.email,
        name: user.name,
        size: AvatarSize.Large
      })
    }), /*#__PURE__*/_jsxs(DropdownMenu, {
      id: menuId,
      triggerId: triggerId,
      open: showDropdown,
      onRequestClose: handleDropdownClose,
      alignment: "right",
      children: [/*#__PURE__*/_jsx(DropdownSection, {
        children: /*#__PURE__*/_jsxs(UserInfoBox, {
          children: [/*#__PURE__*/_jsx(Avatar, {
            email: user.email,
            name: user.name,
            size: AvatarSize.Medium
          }), /*#__PURE__*/_jsxs(UserDetails, {
            children: [/*#__PURE__*/_jsx(UserName, {
              children: user.name
            }), /*#__PURE__*/_jsx(UserEmail, {
              children: user.email
            })]
          })]
        })
      }), menuItems === null || menuItems === void 0 ? void 0 : menuItems.map(function (_ref2) {
        var id = _ref2.id,
          items = _ref2.items;
        return /*#__PURE__*/_jsx(DropdownSection, {
          children: items.map(function (menuItem) {
            return /*#__PURE__*/_jsx(DropdownLink, {
              href: menuItem.href
              // @ts-expect-error Ginger Dropdown is not transformed to TS yet
              ,

              destructive: menuItem.destructive,
              onClick: handleMenuItemClick(menuItem),
              children: menuItem.label
            }, menuItem.id);
          })
        }, id);
      })]
    })]
  });
};
export default /*#__PURE__*/memo(UserDropdown);